(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('stShowInactive', stShowInactive)
     
    /* @ngInject */
    function stShowInactive() {
        var directive = {
            restrict: 'A',
            require: '^stTable',
            link: link,
            bindToController: true
        };

        return directive;

        function link(scope, element, attrs, ctrl) {
            
            scope.$watch('vm.showInactive', function (value) {
                ctrl.search(!value, 'Active');
            })
            return ctrl.pipe();
        }
    }
})();
